/* eslint-disable react/prop-types */
import { getState } from "../../../state/store";
import { selectAppsMarkets } from "../../../state/selectors";

import { alignItems, colors, strCode, tableDataStatuses } from "../../../consts";
import { t } from "../../../services";
import { dateUtil } from "../../../utils";

import {
  FlexContainers,
  GradientLoader,
  StatusIndicator,
  SVG,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";
import { OpenAppButton } from "./styled";

const getAppMarkets = (market) => {
  const appsMarkets = selectAppsMarkets()(getState());

  return appsMarkets[market]?.map((market) => market.market).join(", ");
};

export const AppsTableColumns = [
  {
    Header: strCode.APP_NAME_TITLE,
    accessor: "name",
    Cell: ({ cell, searchedText, cellWidth8, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper
            highlightedText={searchedText}
            style={{
              color: colors.RAISIN_70
            }}>
            {isLoading ? (
              <GradientLoader width={308} height={24} animationDuration={16} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.MARKETS_TITLE,
    Cell: ({ cell, cellWidth8, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper
            style={{
              color: colors.RAISIN_70
            }}>
            {isLoading ? (
              <GradientLoader width={172} height={24} animationDuration={24} />
            ) : (
              getAppMarkets(cell.row.original.appType)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.OWNER_TITLE,
    accessor: "createdBy",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <WrapperContainer
            Container={FlexContainers.FlexColumn}
            alignItems={alignItems.start}
            gap={4}>
            <TextOverflowWrapper
              style={{
                color: colors.RAISIN_70
              }}>
              {isLoading ? (
                <GradientLoader width={160} height={24} animationDuration={32} />
              ) : (
                `${cell.value?.firstName || ""} ${cell.value?.lastName || ""}`
              )}
            </TextOverflowWrapper>

            <TextOverflowWrapper>
              {isLoading ? (
                <GradientLoader width={160} height={24} animationDuration={32} />
              ) : (
                <p
                  style={{
                    color: colors.RAISIN_70,
                    fontSize: "14px",
                    whiteSpace: "pre"
                  }}
                  dangerouslySetInnerHTML={{
                    __html: dateUtil.formatDateFromTimestamp(cell.row.original.createdAtTs)
                  }}
                />
              )}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.LAST_MODIFIED_TITLE,
    accessor: "lastModifiedBy",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <WrapperContainer
            Container={FlexContainers.FlexColumn}
            alignItems={alignItems.start}
            gap={4}>
            <TextOverflowWrapper
              style={{
                color: colors.RAISIN_70
              }}>
              {isLoading ? (
                <GradientLoader width={160} height={24} animationDuration={32} />
              ) : (
                `${cell.value?.firstName || ""} ${cell.value?.lastName || ""}`
              )}
            </TextOverflowWrapper>

            <TextOverflowWrapper>
              {isLoading ? (
                <GradientLoader width={160} height={24} animationDuration={32} />
              ) : (
                <p
                  style={{
                    color: colors.RAISIN_70,
                    fontSize: "14px",
                    whiteSpace: "pre"
                  }}
                  dangerouslySetInnerHTML={{
                    __html: dateUtil.formatDateFromTimestamp(cell.row.original.lastModifiedAtTs)
                  }}
                />
              )}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },

  {
    Header: strCode.ACTIVE_USERS,
    accessor: "activeUserCount",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width="85px">
          <TextOverflowWrapper
            style={{
              width: "100%",
              textAlign: "end",
              color: colors.RAISIN_70
            }}>
            {isLoading ? (
              <GradientLoader width={84} height={24} animationDuration={40} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.STATUS_TITLE,
    id: "active",
    accessor: (row) => {
      return !row.isDisabled ? "active" : "inactive";
    },
    Cell: ({ cell, isLoading }) => (
      <CellWrapper width={"100px"}>
        {isLoading ? (
          <GradientLoader width={82} height={24} animationDuration={32} />
        ) : (
          <StatusIndicator status={tableDataStatuses[cell.value]} />
        )}
      </CellWrapper>
    )
  },
  {
    accessor: "link",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width="100%" justifyContent="flex-end">
          <WrapperContainer width="156px">
            {isLoading ? (
              <GradientLoader width={140} height={24} animationDuration={32} />
            ) : (
              <OpenAppButton
                secondary
                secondaryBold
                small
                onClick={(event) => {
                  event.stopPropagation();
                  window.open(cell.value, "_blank", "noopener noreferrer");
                }}>
                <SVG.OpenElementIcon />
                {t(strCode.OPEN_APP_TITLE)}
              </OpenAppButton>
            )}
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
